import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IonDatetime } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'custom-input',
  templateUrl: './custom-input.page.html',
  styleUrls: ['./custom-input.page.scss'],
})
export class CustomInputComponent implements OnInit {
  @Input() props: any;
  @Input() classname: string = '';
  @Input() formgroup: FormGroup;
  @Input() formcontrolname: string;
  @Input() ionInput: boolean = false;
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() min: string;
  @Input() max: string;
  @Input() displayFormat: string = 'MM/YY';
  @Input() pickerFormat: string = 'MM YYYY';
  @ViewChild('ionDateTime') ionDateTime: IonDatetime;
  @Input() interfaceoptions: Object = {};
  @Input() disabled = false;
  @Input() maxlength: number | string;
  @Input() pattern: string;
  @Input() labelColor: string;
  @Input() showRequired: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit() {}
  labelClick(type) {
    if (type == 'date') this.ionDateTime.open();
  }

  isRequired() {
    return (
      this.formgroup.get(this.formcontrolname)?.validator &&
      this.formgroup.get(this.formcontrolname).validator({} as any)?.required
    );
  }

  // Generic function to get the error message based on validation
  getError(fieldName: string): string {
    const control = this.formgroup.get(fieldName);
    if (!(control && (control.touched || control.dirty) && control.errors)) return '';

    const errors = control.errors;

    const messages: { [key: string]: string } = {
      required: this.translate.instant('CUSTOM_INPUT.REQUIRED'),
      requiredTrue: this.translate.instant('CUSTOM_INPUT.REQUIRED_TRUE'),
      email: this.translate.instant('CUSTOM_INPUT.EMAIL'),
      pattern: this.translate.instant('CUSTOM_INPUT.PATTERN'),
      match: this.translate.instant('CUSTOM_INPUT.MATCH'),
    };

    if (errors['minlength']) {
      return `Minimum ${errors['minlength'].requiredLength} characters required.`;
    }

    if (errors['maxlength']) {
      return `Maximum ${errors['maxlength'].requiredLength} characters allowed.`;
    }

    if (errors['min']) {
      return `Value must be at least ${errors['min'].min}.`;
    }

    if (errors['max']) {
      return `Value must be at most ${errors['max'].max}.`;
    }

    const firstKey = Object.keys(errors)[0];
    return messages[firstKey] || this.translate.instant('CUSTOM_INPUT.INVALID_FIELD');
  }
}
